
import { formatDate, parseISODate } from '@/utils/date'
import { getDefaultAvatar } from '@/utils/ui'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RequestedMemberListItem',
  props: {
    id: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      default: undefined
    },
    hideBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    joining(): string {
      return formatDate(parseISODate(this.createdAt))
    }
  },
  methods: {
    getDefaultAvatar,
    acceptRequest(): void {
      this.$emit('acceptRequest', this.id)
    },
    rejectRequest(): void {
      this.$emit('rejectRequest', this.id)
    }
  }
})
